module.exports = __webpack_public_path__ + "img/low-bg.43e86ad4.png";